// extracted by mini-css-extract-plugin
export var fadeIn = "skills-module--fadeIn--s5PB6";
export var fadeUp = "skills-module--fadeUp--oR22-";
export var list = "skills-module--list--yh4JM";
export var skillList = "skills-module--skill-list--GmxPz";
export var skillSet = "skills-module--skill-set--qXEYB";
export var skillSetVisible = "skills-module--skill-set--visible--czeyH";